// src/monitoring-client.ts
import { createFallbackMonitoringClient } from "@wix/monitoring";
import { createSentryBrowserClient } from "@wix/monitoring-browser-sentry";
import {
  createPanoramaBrowserClient
} from "@wix/monitoring-browser-panorama";
var isSentryConfig = (monitoringConfig) => monitoringConfig?.type === "SENTRY";
var isPanoramaConfig = (monitoringConfig) => monitoringConfig?.type === "PANORAMA";
var getMonitoringClientFunction = ({
  sentrySDK,
  sentryTransport,
  panoramaClient,
  monitoringConfig,
  hostContext
}) => {
  if (isSentryConfig(monitoringConfig)) {
    const { sentryOptions } = monitoringConfig;
    return () => createSentryBrowserClient({
      dsn: sentryOptions?.dsn,
      hostContext,
      sentrySDK,
      transport: sentryTransport
    });
  } else if (isPanoramaConfig(monitoringConfig)) {
    return () => createPanoramaBrowserClient({ panoramaClient });
  }
  return () => createFallbackMonitoringClient(
    "Invalid monitoring configuration. Please check the monitoring setup of your application."
  );
};
export {
  getMonitoringClientFunction
};
